import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./main/header";
import Nav from "./main/nav";
import Footer from "./main/footer";
import DateRange from "./main/DateRange";
import Swal from "sweetalert2";
import axios from "axios";
// import { reports } from "../main/Api";
// // import DownloadExcel from "../page";
// import ReportsManu from "./reportsManu";
import { AccessToken, APIBaseURL } from "../Config";
import { formatToDateTime } from "./main/formatToDateTime";

import GoogleMapNew from "./GoogleMapNew";
// GoogleMap2
export default function CHEUtilizationOnlyTable(dd) {
  const equipment_name = dd.dd.equipment_name;
  const ViewType = dd.dd.type;
  // alert(ViewType);

  const center = {
    lat: 28.6139, // Default latitude (e.g., Delhi)
    lng: 77.2090, // Default longitude
  };

  // const equipment_name = dd.equipment_name;
  // alert(JSON.stringify(dd));

  const [type, setType] = useState("Container TAT");
  const [data, setData] = useState();

  const [loading, setLoading] = useState(false);
  const [containerNo, setContainerNo] = useState("");
  const [equipmentId, setEquipmentId] = useState(
    dd?.dd?.equipment_name ?? null
  );
  const [start, setStart] = useState(dd?.dd?.start ?? "");
  const [end, setEnd] = useState(dd.dd?.end ?? "");
  const [equipments, setEquipments] = useState([]);

  const [ViewInMap, setViewInMap] = useState(null);

  const GetData = async (page = 1) => {
    setLoading(true);
    let url = `${APIBaseURL}/get/containers/transactions?page=` + page;
    if (equipment_name) {
      url += `&equipment_id=${equipment_name}&type=${ViewType}`;
    }

    if (containerNo) {
      url += `&container_no=${containerNo}`;
    }
    if (start) {
      url += `&start=${start}`;
    }
    if (end) {
      url += `&end=${end}`;
    }
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          access_token: `${AccessToken}`,
        },
      });
      if (response.data && response.data.data) {
        setData(response.data.data);
      } else {
        Swal.fire({
          icon: "info",
          text: "Something went wrong..!",
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   GetData();
  //   // alert(JSON.stringify(equipmentId));
  // }, [equipmentId]);

  useEffect(() => {
    // alert(JSON.stringify(dd));
    setData(null);
    GetData();
  }, [dd]);

  const GetEquipment = async () => {
    setLoading(true);
    let url = `${APIBaseURL}/get/equipments`;

    try {
      const response = await axios.get(url);
      if (response.data && response.data.status == "success") {
        setEquipments(response.data.data);
      } else {
        Swal.fire({
          icon: "Info",
          text: `Something Want Wrong..! `,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        text: `Error in Data Fetch: ${error.message}`,
        timer: 3000,
        showConfirmButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetEquipment();
  }, []);

  const handleDataFilter = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    setEquipmentId(formData.get("equipment_id") || "");
    setContainerNo(formData.get("container_no") || "");
    let range = formData.get("range");
    if (range) {
      let [startDateTime, endDateTime] = range.split(" ~ ");
      setStart(startDateTime);
      setEnd(endDateTime);
    }
  };
  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      ) : (
        ""
      )}

      {ViewInMap ? (
        <>
          <button className="btn btn-danger mb-3" onClick={()=>setViewInMap(null)}>Close Map & view List</button> 
          <GoogleMapNew data={ViewInMap} ></GoogleMapNew>
        </>
      ) : (<>
        <div className="row my-3">
          <div className="">
            <div className="card-body px-1">
              <div className="table-responsive text-nowrap">
                {/* {JSON.stringify(ViewInMap)} */}
                {start}
                <table className="table table-hover table-font table-striped">
                  <thead>
                    <tr className="table-primary">
                      <td>S No.</td>
                      <td>Container No.</td>
                      <td>Container Size</td>
                      <td>Equipment Name</td>
                      <td>From Location</td>
                      <td>To Location</td>
                      <td>Timestamp</td>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.data &&
                      data?.data.map((report, index) => (
                        <tr
                          key={index}
                          onClick={() => {
                            if (ViewType !== 'productive') {
                              setViewInMap(report);
                            }
                          }}
                        >
                          {/* ViewType != 'productive' */}
                          <td>
                            <span>{index + 1}</span>
                          </td>
                          <td>
                            <span>{report.containerno}</span>
                          </td>
                          <td>
                            {(isNaN(report.containersize)
                              ? report?.container_master?.container_size
                              : report.containersize) ?? "40"}
                            {/* <span>{report.containersize}Ft</span> */}
                          </td>
                          <td>
                            <span>{report.equipmentid}</span>
                          </td>
                          <td>
                            <span>{report.locklocation}</span>
                          </td>
                          <td>
                            <span>{report.unlocklocation}</span>
                          </td>
                          <td>
                            <span>{formatToDateTime(report.unlockdatetime)}</span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                {data && data.data && (
                  <div className="container mt-4">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <div
                          className="dataTables_info"
                          id="DataTables_Table_0_info"
                          role="status"
                          aria-live="polite"
                        >
                          Showing {data.from} to {data.to} of {data.total} entries
                        </div>
                      </div>
                      <div className="col-10 m-auto mt-2">
                        <div
                          className="dataTables_paginate paging_simple_numbers"
                          id="DataTables_Table_0_paginate"
                        >
                          <ul className="pagination ">
                            {data &&
                              data.links &&
                              data.links.map((link, q) => {
                                let showData =
                                  data.links.length == q + 1
                                    ? "Next"
                                    : q == 0
                                      ? "Previous"
                                      : link.label;
                                return (
                                  <li
                                    key={q}
                                    className={`paginate_button page-item ${link.active === true ? "active" : ""
                                      }  ${showData == "Next" &&
                                        data.current_page == data.last_page
                                        ? "disabled"
                                        : showData == "Previous" &&
                                          data.current_page == 1
                                          ? "disabled"
                                          : ""
                                      } `}
                                  >
                                    <button
                                      onClick={() => {
                                        showData == "Previous"
                                          ? GetData(data.current_page - 1)
                                          : showData == "Next"
                                            ? GetData(data.current_page + 1)
                                            : GetData(link.label);
                                      }}
                                      aria-controls="DataTables_Table_0"
                                      role="link"
                                      aria-current="page"
                                      data-dt-idx={0}
                                      tabIndex={0}
                                      className="page-link"
                                    >
                                      {showData}
                                    </button>
                                  </li>
                                );
                              })}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>


      </>)}

    </>
  );
}
